import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

export default class TopbarMenuLinks extends PureComponent {
    static propTypes = {
        icon: PropTypes.string,
        path: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
    };

    render() {
        return (
            <Link className='topbar__link' to={this.props.path}>
                {this.props.icon ? <span className={`topbar__link-icon lnr lnr-${this.props.icon}`}/> : null}
                <p className='topbar__link-title'>{this.props.title}</p>
            </Link>
        )
    }
}


// WEBPACK FOOTER //
// ./src/theme/pages/_layout/topbar/TopbarMenuLink.js